import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles,withStyles ,DialogTitle,Dialog,DialogContent} from '@material-ui/core';
import Paragraph from "./Contentbodyinputs/Paragraph";
import Image from "./Contentbodyinputs/ImageVideo";
import Editor from './Contentbodyinputs/AvatarImageInput';
import { v4 as uuidv4 } from "uuid";
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import InsertPhotoIcon from '@material-ui/icons/InsertPhoto';
import MovieIcon from '@material-ui/icons/Movie';
import AuthenticatedPage from "../ContextAndHOC/AuthenticatedPage";
import CircularProgress from '@material-ui/core/CircularProgress';
import {StatusCodes} from 'http-status-codes';

const useStyles = makeStyles(theme => ({
createUser: {minWidth: "150px !important", textTransform: "uppercase", backgroundColor: "rgba(75, 123, 227, 1)",
color: '#fff', borderRadius: "25px", border: "1px solid ", marginLeft: "16px", fontWeight: "500 !important",
'&:hover': { color: '#1d5d90',  border: "1px solid " },[theme.breakpoints.down("sm")]: {width: "120%",marginLeft:"-15px"}},
cancelBtn: { width: "150px", height: "36px", textTransform: "uppercase", backgroundColor: "rgba(255, 255, 255, 1)",
color: "rgba(75, 123, 227, 1)", borderRadius: "25px", border: "1px solid rgba(0, 0, 0, 0.12)", marginLeft: 25, fontWeight: "500 !important",
'&:hover': { color: '#1d5d90',  border: "1px solid " },[theme.breakpoints.down("sm")]: {width: "100%",marginLeft:0}},
dialogWidth:{padding:"15px",maxHeight: '400px !important'}}));
const Newcontentbody = props => {
  const [text, setText] = React.useState([]);
  const [load, setLoad] = React.useState(false);
  const classes = useStyles();
  const [errormessage,setErrormessage]=React.useState('');
  React.useEffect(() => {
    if (props.text.length > 0) {
      setText(props.text);
    }
  }, [props]);

  const getvalue = (htmltext) => {
    let value = "";
    let newString = "";
    htmltext.map(val => {
      if (val.type === "header") {
        let htmlpar = `<p style='font-size:1em;color:#747681;font-weight:500;font-family: $#font-family1#$;'> ${val.value}</p>`;
        value = value + htmlpar;
      }
      if (val.type === "paragraph") {
        let htmlpar = `<p style='font-size:1em;color:#747681;font-weight:400;font-family: $#font-family1#$;'> ${val.value}</p>`;
        value = value + htmlpar;
      }
      else if (val.type === "list") {
          if (val.ul) {
            let htmlpar =
              "<ul>" +
              val.value.map(list => {
                return `<li style='font-size:1em;color:#747681;font-weight:400;font-family:$#font-family2#$;'>${list.value}</li>`;
              }) +
              "</ul>";
            newString= htmlpar.replace(/\,/g, '');
            value = value + newString;
          } else {
            let htmlpar =
              "<ol>" +
              val.value.map(list => {
                return `<li style='font-size:1em;color:#747681;font-weight:400;font-family:$#font-family2#$;'>${list.value}</li>`;
              }) +
              "</ol>";
          newString= htmlpar.replace(/\,/g, '');
            value = value + newString;
          }
        } 
      if (val.type === "image") {
        let htmlpar = `<div><img src='${val.url}' width='100%'/></div>`;
        value = value + htmlpar;
      }
      if (val.type === "video") {
        let htmlpar = `<video width='100%' height='50%' poster='$*image-url*$/Articles/big_buck_bunny.jfif' controls> <source src='${val.url}' type=video/mp4> </video>`;
        value = value + htmlpar;
      }
    });
    return value;
  };
  const handleClickheader = () => {
    let head = {
      id: Date(),
      type: "header",
      value: ""
    };
    text.push(head);
    setText([...text]);
  };
  const handleClickPara = () => {
    let head = {
      id: Date(),
      type: "paragraph",
      value: ""
    };
    text.push(head);
    setText([...text]);
  };
  const handleClickListOL = () => {
    let head = {
      id: uuidv4(),
      type: "list",
      ul: false,
      value: ""
    };
    text.push(head);
    setText([...text]);
  };
  const handleClickListUl = () => {
    let head = {
      id: Date(),
      type: "list",
      ul: true,
      value: ""
    };
    text.push(head);
    setText([...text]);
  };
  const handleimage = () => {
    let head = {
      id: Date(),
      type: "image",
      value: " ",
      url: ""
    };
    text.push(head);
    setText([...text]);
  };
  const handlevideo = () => {
    let head = {
      id: Date(),
      type: "video",
      value: " ",
      url: ""
    };
    text.push(head);
    setText([...text]);
  };
  const setPValue = (val, i) => {
    text[i].value = val;
    setText([...text]);
  };

  const handleDeletetext = id => {
    const deletedtext = text.filter(item => item.id !== id);
    setText(deletedtext);
  };
  const handleSubmit = () => {
let sendingvalue=0;
    text.map((values) => {
      if (values.type === "video" || values.type === "image") {
        if (values.value === ' ' && values.url === '') {
          sendingvalue = sendingvalue + 1;
        }
      } else {
        if (values.value === '') {
          sendingvalue = sendingvalue + 1;
        }
      }
    });
if(sendingvalue>0){
setErrormessage("Please fill all fields");
sendingvalue=0;
} else{
sendingvalue=0;
    setLoad(true);
    const Isimage = text.filter((val) => {
      if (val.type === "video"||val.type === "image" ) {
        return true;
      }
      return false;
    });
    setErrormessage('');
    let sendimagevalue=true;
    if (Isimage.length > 0) {
      const data = new FormData();
      text.map((val) => {
        if ((val.type === "video"&&val.value!==" ")||(val.type === "image"&&val.value!=="")) {
          data.append(`imagefile`, val.value,`${"Article&"+props.resourcesid+"_content_body_"+uuidv4()+"."+val.value.type.substr(val.value.type.indexOf('/')+1)}`);
        sendimagevalue=false;
}
      });
if(sendimagevalue){
const finalvalue = getvalue(text);
props.handleBodysubmit(finalvalue,text);
} else{
      let resdata = [];
      async function sendFile() {
        let count = 0;
        let url = "/api/content/contentservice/contentToolFileUpload";
        let response1 = await props.authenticatedApiCall("post", url, data);
        setLoad(false);
        if (response1 && response1.status === StatusCodes.OK) {
          if (response1.data.result) {
            response1.data.result.map((res) => {
              return resdata.push(props.currentUser.config.s3BucketBaseUrl+res.Key);
            });
            text.map(val => {
              if (val.type === "video"&&val.value!==" ") {
                val.url = resdata[count];
              } else if (val.type === "image"&&val.value!=="") {
                val.url = resdata[count];
              }
              if (val.type === "video" || val.type === "image") {
               if(val.value!==""){
                count = count + 1;
              }
              }
            });
            const finalvalue = getvalue(text);
            props.handleBodysubmit(finalvalue, text);
          }
        } else {
          setErrormessage("Please Submit Again");
        }
      }
      sendFile();
}
} else {
      const finalvalue = getvalue(text);
      props.handleBodysubmit(finalvalue, text);
    }
}
  };
  return (
    <>
      <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" maxWidth='xl' >
          <DialogTitle style={{textAlign:"center"}}>
          <Button variant="outlined" color="primary" onClick={handleClickheader}>Header </Button>
          <Button variant="outlined" color="primary" style={{ marginLeft: "30px" }} onClick={handleClickPara}>Paragraph</Button>
          <Button variant="outlined" color="primary" style={{ marginLeft: "30px" }} onClick={handleClickListOL}><FormatListNumberedIcon /></Button>
          <Button variant="outlined" color="primary" style={{ marginLeft: "30px" }} onClick={handleClickListUl}><FormatListBulletedIcon /></Button>
          <Button variant="outlined" color="primary" style={{ marginLeft: "30px" }} onClick={handleimage}><InsertPhotoIcon /></Button>
          <Button variant="outlined" color="primary" style={{ marginLeft: "30px" }} onClick={handlevideo}><MovieIcon /></Button>
          </DialogTitle>
          <DialogContent className={classes.dialogWidth}>
          {text
            ? text.map((val, index) => {
              if (val.type === "header" || val.type === "list" || val.type === "link" || val.type === "paragraph") {
                return (
                  <Paragraph key={index} text={val} setTexts={changedValue => setPValue(changedValue, index)} handleDeletetext={handleDeletetext} />
                );
              } else if (val.type === "image") {
                return (<Editor keyid={index} text={val} setTexts={changedValue => setPValue(changedValue, index)}
                  handleDeletetext={handleDeletetext} />);
              } else {
                return (
                  <Image keyid={index} text={val} setTexts={changedValue => setPValue(changedValue, index)} handleDeletetext={handleDeletetext} />
                );
              }
            })
              : ""}
          <br />
          <br />
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <Button className={classes.cancelBtn} onClick={props.handleClose}>Cancel</Button>
             {errormessage&&errormessage.length>1?<p style={{color:"red",paddingTop:"10px"}}>{errormessage}</p>:""}
            <Button className={classes.createUser} onClick={handleSubmit}>Submit</Button>
          </div>
          {load && <CircularProgress color="primary" style={{position: "absolute",left: "40%",top:"50%"}} />}
{/* </div> */}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default (withStyles() (AuthenticatedPage()(Newcontentbody)));
